import { envIsCanada, envIsMexico, envIsNormal, envIsSweden } from '@/constants/constants';
import { FluidKycStatus } from '@fluidpayments/types';
import { isRegulatedLocale } from '@/shared/utility';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import {
  GAMES_FEATURES_CANADA,
  GAMES_FEATURES_MEXICO,
  GAMES_FEATURES_NORMAL,
  GAMES_FEATURES_THAILAND,
} from '@/constants/games-constants';

export const isSplashTechEnabled = (
  locale: string,
  isTester: boolean,
  isWheelRestricted: boolean,
): boolean => {
  if (isWheelRestricted) {
    return false;
  }

  if (isTester) {
    return true;
  }

  if (envIsSweden()) {
    return false;
  }

  if (envIsMexico() || envIsCanada()) {
    return true;
  }

  return ['ca', 'ca-fr', 'at', 'th', 'nz', 'row'].includes(locale);
};

// For the given currency code, convert the amount to the jackpot amount, because we get the jackpot amounts usually in EUR
export const convertJackpotAmount = (currencyCode: string, amount: number) => {
  const MULTIPLIERS: Record<string, number> = {
    NOK: 10,
    ZAR: 16,
    THB: 40,
  };

  const currencyMultiplier = MULTIPLIERS[currencyCode] || 1;

  return amount * currencyMultiplier;
};

export const isCuracao = (locale: string): boolean => {
  return envIsNormal() && ['row', 'at', 'nz', 'za', 'ae', 'th'].includes(locale);
};

export const shouldDisplayFTDExitIntent = (
  depositCount: number | null,
  hasWelcomeBonuses: boolean,
  isFtdExitIntentShown: boolean,
  locale: string,
  kycStatus: FluidKycStatus | undefined,
): boolean => {
  if (depositCount !== null && depositCount > 0) {
    return false;
  }

  if (!hasWelcomeBonuses) {
    return false;
  }

  if (isFtdExitIntentShown) {
    return false;
  }

  if (envIsCanada() || envIsMexico() || isCuracao(locale)) {
    return kycStatus !== 'processing';
  }

  return true;
};

export const gamesFeaturesList = (locale: string) => {
  if (envIsMexico()) {
    return [...GAMES_FEATURES_MEXICO];
  }

  if (envIsCanada()) {
    return [...GAMES_FEATURES_CANADA];
  }

  if (envIsNormal() && locale === 'th') {
    return [...GAMES_FEATURES_THAILAND];
  }

  if (envIsNormal() && !isRegulatedLocale(locale)) {
    return [...GAMES_FEATURES_NORMAL];
  }

  return [];
};

// Parses affiliateId in format "6digits_alphanumeric" (e.g. "123456_abc123")
export const parseAffiliateId = (
  affiliateId: string,
): { btag: string; referenceNumber: string } | undefined => {
  if (!affiliateId) return undefined;

  const [btag, referenceNumber] = affiliateId.split('_');

  if (!btag || !referenceNumber) return undefined;

  return { btag, referenceNumber };
};

export const providerCategoryRoutes = (locale: string) => {
  const normalCategories = [BffGamesCategory.Slots];

  return [...normalCategories, ...gamesFeaturesList(locale)];
};
